const PREDEFINED_STATUS_CODE_MESSAGES: Record<number, string> = {
  400: 'HTTP 400: Bad Request',
  401: 'HTTP 401: Session expired, please log in again',
  403: 'HTTP 403: Forbidden',
  500: 'HTTP 500: Unknown Server Error',
  502: 'HTTP 502: Bad Gateway',
  504: 'HTTP 504: Gateway Timeout',
};

export default PREDEFINED_STATUS_CODE_MESSAGES;
